import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { SpeedInsights } from "@vercel/speed-insights/react"
import './index.css'
import 'mapbox-gl/dist/mapbox-gl.css'

import { router } from '@/routes';
import { AuthProvider, GroupsProvider, HomesProvider, ReactQueryProvider } from '@/contexts';
import { Provider } from './components/ui/provider';
import { config } from "@mapbox/search-js-react";
import { PostHogProvider } from '@posthog/react';
import { postHogService } from '@/lib/posthog';

config.accessToken = import.meta.env.VITE_MAPBOX_ACCESS_TOKEN;

// Initialize PostHog
postHogService.init();

// Enable MSW mocking in development if enabled
async function enableMocking() {
  if (import.meta.env.VITE_ENABLE_MOCKS !== 'true') {
    return;
  }

  const { worker } = await import('./mocks/browser');

  return worker.start({
    onUnhandledRequest: 'bypass',
  });
}

enableMocking().then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <PostHogProvider client={postHogService.client}>
        <Provider>
          <ReactQueryProvider>
            <AuthProvider>
              <HomesProvider>
                <GroupsProvider>
                  <RouterProvider router={router} />
                </GroupsProvider>
              </HomesProvider>
            </AuthProvider>
          </ReactQueryProvider>
        </Provider>
      </PostHogProvider>
      <SpeedInsights />
    </StrictMode>,
  );
});
